<script lang="ts">
    let className: string = "";
    export {className as class};
    export let style: string = "";
</script>

<svg
        {style}
        class={className} 
   width="18.604166"
   zoomAndPan="magnify"
   viewBox="0 0 13.953125 17.937499"
   height="23.916666"
   preserveAspectRatio="xMidYMid meet"
   version="1.0"
   id="svg830"
   sodipodi:docname="amalyse.svg"
   inkscape:version="1.1.1 (c3084ef, 2021-09-22)"
   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg">
  <defs
     id="defs834" />
  <sodipodi:namedview
     id="namedview832"
     pagecolor="#ffffff"
     bordercolor="#666666"
     borderopacity="1.0"
     inkscape:pageshadow="2"
     inkscape:pageopacity="0.0"
     inkscape:pagecheckerboard="0"
     showgrid="false"
     fit-margin-top="0"
     fit-margin-left="0"
     fit-margin-right="0"
     fit-margin-bottom="0"
     inkscape:zoom="0.6046875"
     inkscape:cx="239.79328"
     inkscape:cy="15.710594"
     inkscape:window-width="1920"
     inkscape:window-height="967"
     inkscape:window-x="0"
     inkscape:window-y="25"
     inkscape:window-maximized="1"
     inkscape:current-layer="svg830" />
  <path
     fill="#f9fbfd"
     d="m 6.976559,1.9999999e-6 c 3.85547,0 6.97657,1.7812500000001 6.97657,3.9843700000001 0,2.20313 -3.1211,3.98828 -6.97657,3.98828 -3.85156,0 -6.97656,-1.78515 -6.97656,-3.98828 0,-2.20312 3.125,-3.9843700000001 6.97656,-3.9843700000001 z M 12.652339,8.101562 c 0.46485,-0.26172 0.90625,-0.58203 1.30079,-0.94922 v 1.81641 c 0,2.20312 -3.1211,3.98437 -6.97657,3.98437 -3.85156,0 -6.97656,-1.78125 -6.97656,-3.98437 v -1.81641 c 0.39453,0.36719 0.83984,0.6875 1.30469,0.94922 1.52344,0.87109 3.53515,1.36328 5.67187,1.36328 2.14063,0 4.14844,-0.49219 5.67578,-1.36328 z M -10e-7,12.136722 v 1.8164 c 0,2.20313 3.125,3.98438 6.97656,3.98438 3.85547,0 6.97657,-1.78125 6.97657,-3.98438 v -1.8164 c -0.39454,0.36718 -0.83594,0.68359 -1.30079,0.94921 -1.52734,0.8711 -3.53515,1.36329 -5.67578,1.36329 -2.13672,0 -4.14843,-0.49219 -5.67187,-1.36329 -0.47266,-0.26562 -0.90625,-0.58203 -1.30469,-0.94921 z m 0,0"
     fill-opacity="1"
     fill-rule="evenodd"
     id="path828" />
</svg>
